import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common";
import clsx from "clsx";
import st from "@/styles/CreditItem.module.scss";
import StaticRangeSlider from "@/ui/StaticRangeSlider.tsx";
import Button from "@/ui/Button.tsx";
import DashboardClass from "@/utils/dashboard_class";
import {useNavigate} from 'react-router-dom';
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import useCommon from "@/hooks/common.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import {DownloadIcon} from "lucide-react";
import React from "react";

interface ItemProps {
    obj: LoanInterface
    cr_line_item?:boolean
    line_history?:boolean
}


const CreditItem:React.FC<ItemProps> = ({obj, line_history}) => {
    
    const {
        capital,
        product_group,
        nr_of_installments,
        urn,
        origin_created_at,
        inst_amount,
        installments_paid,
        installments,
        r_status_simplified,
        r_status,
        restant_days,
        product_name,
        document_received_at
    } = obj
    
    
    const {t} = useTranslation()
    const dc = DashboardClass
    const navigate = useNavigate();
    const common_hook = useCommon()
    const settled = r_status === "settled" || r_status === "closed"
    
    const data_row = [
        {
            label: t("date"),
            value: common_hook.formatMomentDate(origin_created_at),
            copy: false,
            visible: product_group === "Credit Line"
        },
        {
            label: t("amount"),
            value: CommonClass.formatMoneyAmount(Number(capital)) + " " + t("currency"),
            copy: false,
            visible: product_group !== "Credit Line"
        },
        {
            label: t("period"),
            value: nr_of_installments + " " + t(CommonClass.time_word_handling(nr_of_installments, true)),
            copy: false,
            visible: product_group !== "Credit Line",
        },
        {
            label: t("monthly_payment"),
            value: (Array.isArray(installments) && installments.length) ? CommonClass.formatMoneyAmount(Number(installments[0].amount)) + " " + t("currency") : "",
            copy: true,
            visible: product_group === "Credit Line"
        },
        {
            label: t("monthly_payment"),
            value: CommonClass.formatMoneyAmount(Number(inst_amount)) + " " + t("currency"),
            copy: false,
            visible: product_group !== "Credit Line" && r_status !== "settled" && r_status !== "closed"
        },
        {
            label: t("urn").toUpperCase(),
            value: urn,
            copy: true,
            visible: r_status === "settled" || r_status === "closed"
        },
        {
            label: line_history ? t("credit_line_nr") : t("transaction_nr"),
            value: urn,
            copy: false,
            visible:  product_group === "Credit Line"
        },
    ]
    
    const getDetails = () => {
        navigate(dc.dashboard_routes.Credit+"/"+urn)
    }
    
    return (
        <div
            className={clsx(
                st.credit_item,
                restant_days > 0 && st.restant,
                settled && st.paid,
                (r_status_simplified === "success" && !restant_days) && st.accepted,
                (r_status_simplified === "danger" && !restant_days) && st.danger,
                (r_status_simplified === "pending" && !restant_days)  && st.pending,
                (r_status_simplified === "unknown" && !restant_days)  && st.unknown
            )}
        >
            
            {(r_status !== "settled" && r_status !== "closed")? (
                <div className={st.top}>
                    

                    <div
                        className={st.top_left}
                    >
                        <strong onClick={() => common_hook.copyToClipboard(urn)} className={st.urn}>
                            {t("credit_nr").replace('{{name}}', t(product_name))}  {urn}
                        </strong>
                        
                        <span>
                            {t("requested")} {common_hook.formatMomentDate(origin_created_at)}
                        </span>
                    </div>
                    
                    <div className={st.top_right}>
                        <div className={st.status_badge}>
                            {restant_days > 0 ? t("late") : t(r_status)}
                        </div>
                    </div>

                </div>
            ) : (
                <div className={st.top}>
                    
                    <div className={st.top_left}>
                        <strong>
                            {t("paid")}
                        </strong>
                    </div>

                </div>
            )}
            
            <div className={st.center}>
                {data_row.map((data_obj, i) => {
                    
                    const {label, value, copy, visible} = data_obj
                    
                    return (visible && value) && (
                        <div
                            key={`data_obj_${i}`}
                            className={clsx(st.data_obj, copy && st.copy)}
                        >
                            <span>
                                {label}
                            </span>
                            
                            <strong
                                className={clsx((label === t("transaction_nr") || label === t("urn").toUpperCase() ) && st.underlined)}
                                onClick={() => {
                                    common_hook.copyToClipboard(value)
                                }}
                            >
                                {value}
                            </strong>
                            
                            {/*{copy && (*/}
                            {/*    <SimpleCopyButton value={value} className={st.copy}/>*/}
                            {/*)}*/}
                        </div>
                    )
                })}
            </div>

            {settled ? (
                <>
                    {(product_group !== "Credit Line" && document_received_at !== null) ? (
                        <div className={clsx(st.bottom, st.bottom_paid)}>

                            <Button
                                className={st.dwn_contract}
                                outlined
                                onClick={() => {
                                    eventEmitter.emit(CommonClass.ModalEvents.OpenGetContractModal, obj)
                                }}
                            >
                                {t("download_contract")}
                                <DownloadIcon />
                            </Button>

                        </div>
                    ) : null}
                </>
                
            ) : r_status_simplified !== "pending" && (
                <div className={st.bottom} >
                    
                    {r_status_simplified === "success" && (
                        <StaticRangeSlider
                            value={installments_paid || 0}
                            danger={restant_days > 0}
                            max={installments?.length || 0}
                            valuetext={"asd"}
                        />
                    )}
                    
                    <Button onClick={getDetails} outlined className={clsx(st.btn, st.btn_outlined)}>
                        {t("credit_details")}
                    </Button>
                
                </div>
            )}
        
        </div>
    )
}

export default CreditItem